export default "__VITE_ASSET__059ad1f6__"